import { useEffect, useLayoutEffect, useState } from 'react'

import { EMPTY_OBJECT } from '../../../constants/common'

import { useLoadFileById } from './useLoadFileById'

export function useFilePreview({
  apiParams,
  file,
  getFileById,
} = EMPTY_OBJECT) {
  const [signExpired, setSignExpired] = useState(false)

  const {
    file: loadedFile,
    getFileData,
    loading,
    setFile,
  } = useLoadFileById(getFileById)

  useLayoutEffect(() => {
    setFile(null)
  }, [file.id])

  useEffect(() => {
    if (!file?.localUrl && (!loadedFile || signExpired)) {
      if (file.id) {
        getFileData({ apiParams, id: file.id })
      } else if (file) {
        setFile(file)
      }
    }
  }, [file?.localUrl, file.id, loadedFile, signExpired])

  return { file: file?.localUrl ? file : loadedFile, loading, setSignExpired }
}
